import e from "../../singletons/Config/index.js";

const o = o => e.merge(o);

export { o as default };
//# sourceMappingURL=index.js.map
